import React from 'react';
import styles from '../../styles/Pagination.module.css';

// Category page pagination (Bubblegum Pink theme): previous / next arrows and page pills. Long lists show the
// first and last page and the pages around the current one, with "…" between, so the bar stays one short row.
const AROUND = 1; // pages shown on each side of the current one

function pageList(current, total) {
  const pages = [];
  for (let p = 1; p <= total; p++) {
    if (p === 1 || p === total || Math.abs(p - current) <= AROUND
      || (current <= 3 && p <= 4) || (current >= total - 2 && p >= total - 3)) {
      if (pages.length && p - pages[pages.length - 1] > 1) pages.push(p - pages[pages.length - 1] === 2 ? p - 1 : '…');
      pages.push(p);
    }
  }
  return pages;
}

const Arrow = ({ dir }) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={dir === 'prev' ? 'M15 5 L8 12 L15 19' : 'M9 5 L16 12 L9 19'} />
  </svg>
);

const Pagination = ({ totalGames, gamesPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalGames / gamesPerPage);

  const go = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    onPageChange(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className={styles.pagination} aria-label="Pages">
      <div className={styles.bar}>
        <button type="button" className={styles.arrow} onClick={() => go(currentPage - 1)} disabled={currentPage === 1} aria-label="Previous page">
          <Arrow dir="prev" />
        </button>
        {pageList(currentPage, totalPages).map((p, i) => (p === '…'
          ? <span key={`gap-${i}`} className={styles.gap} aria-hidden="true">…</span>
          : (
            <button key={p} type="button" onClick={() => go(p)}
              className={`${styles.page} ${p === currentPage ? styles.active : ''}`}
              aria-label={`Page ${p}`} aria-current={p === currentPage ? 'page' : undefined}>
              {p}
            </button>
          )))}
        <button type="button" className={styles.arrow} onClick={() => go(currentPage + 1)} disabled={currentPage === totalPages} aria-label="Next page">
          <Arrow dir="next" />
        </button>
      </div>
      <span className={styles.info}>Page {currentPage} of {totalPages}</span>
    </nav>
  );
};

export default Pagination;
